import { render, staticRenderFns } from "./TypeConfigCrudListView.vue?vue&type=template&id=6504a56c&scoped=true&"
import script from "./TypeConfigCrudListView.vue?vue&type=script&lang=js&"
export * from "./TypeConfigCrudListView.vue?vue&type=script&lang=js&"
import style0 from "./TypeConfigCrudListView.vue?vue&type=style&index=0&id=6504a56c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6504a56c",
  null
  
)

export default component.exports